
















































import { Component, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import { IUser } from "@/models/users";
import { IState } from "@/store";
import { Methods } from "@/models/methods";
import { mixins } from "vue-class-component";
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";
import { ValidationObserver } from "vee-validate";

@Component({
  computed: {
    ...mapState({
      user: (state: IState) => state.user
    })
  }
})
export default class TwoFactorAuthentication extends mixins(
  HasValidation,
  Context
) {
  public get isLoading() {
    return (
      this.$_.isEmpty(this.user) ||
      (!this.$_.isEmpty(this.user) &&
        !this.hasEnabled2fa &&
        this.qr.length === 0)
    );
  }

  public get hasEnabled2fa() {
    return this.user.enabled_2fa === true;
  }

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    authCode: HTMLFormElement;
  };
  private user!: IUser;
  private qr = "";
  private secret = "";
  private uri = "";
  private authCode = "";
  private isProcessing = false;

  public created() {
    this.get2faSecret();
    this.autofocusInput();
  }

  @Watch("user")
  public async get2faSecret() {
    if (this.$_.isEmpty(this.user)) {
      return;
    }
    if (!this.hasEnabled2fa) {
      const response = await this.$store.dispatch("api/call", {
        method: Methods.GET,
        path: this.isAdmin ? `api/admin/twofa/secret` : `api/twofa/secret`
      });
      this.qr = response.data.qr;
      this.secret = response.data.secret;
      this.uri = response.data.uri;
    }
  }

  public update2fa() {
    this.isProcessing = true;
    let data: {
      secret?: string;
      auth_code?: string;
    } = {
      auth_code: this.authCode
    };

    if (!this.hasEnabled2fa) {
      data = {
        secret: this.secret,
        auth_code: this.authCode
      };
    }
    this.$store
      .dispatch("api/call", {
        method: !this.hasEnabled2fa ? Methods.POST : Methods.DELETE,
        path: `api/${this.isAdmin ? "admin/users" : "clients"}/${
          this.user.id
        }/twofa`,
        requestConfig: { data }
      })
      .then(() => {
        this.$store.dispatch(`auth/${this.context}/getUser`);
        this.$emit("close");
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }

  private autofocusInput() {
    if (!this.isLoading) {
      this.$nextTick(() => {
        this.$refs.authCode.$el.querySelector("input").focus();
      });
    }
  }

  @Watch("isLoading")
  private loaded() {
    this.autofocusInput();
  }
}
